module.exports = __webpack_public_path__ + "img/Logo_JAP.c93711f5.png";